import { formatDate } from '../../filters'
import { bus, helper } from '@/utils'

import UserDelete from '../UserDelete/UserDelete.vue'
import UserInfo from '../UserInfo/UserInfo.vue'

export default {
  beforeDestroy () {
    bus.$off('update-deleted-user-list')
  },
  components: { UserDelete, UserInfo },
  computed: {
    componentTitle () {
      return this.$t(`ComponentTitle.${this.$route.name}`)
    },
    showPagination () {
      return !!this.userList.length
    }
  },
  methods: {
    convertTime (ms) {
      return formatDate(ms)
    },
    deleteUser (id, email) {
      bus.$emit('show-delete-user', {
        show: true,
        info: { id, email }
      })
    },
    async getCurrentPageUser (pageNumber) {
      this.pagination.offset = this.pagination.limit * (pageNumber - 1)
      await this.getUsers(this.searchQuery)
    },
    getTotal () {
      const query = { fields: JSON.stringify(['users']) }
      return this.$api.getTotal(query)
        .then((ret) => ret.data)
        .catch(() => ({}))
        .then((total) => {
          this.total = total
        })
    },
    getUserInfo (id) {
      this.isLoadingInfo = true

      return this.$api.getUser({ id })
        .then(res => {
          this.userInfo = res.data
          this.isLoadingInfo = false
        })
    },
    getUsers (email = '') {
      this.isLoading = true

      const query = { limit: this.pagination.limit, offset: this.pagination.offset }

      if (email.trim()) {
        query.filter = JSON.stringify({email})
      }

      return this.$api.getUsers(query)
        .then(res => this.showList(res.data))
        .catch((error) => helper.showErrorMessage(this, this.component, error))
    },
    handleExpand (row, expanded) {
      const arr = []
      expanded.forEach(({ id }) => {
        const alreadyIn = this.expanded.indexOf(id) !== -1
        if (!alreadyIn) {
          this.getUserInfo(id)
          arr.push(id)
        }
      })

      this.expanded = arr
      return expanded
    },
    getRowKey (row) {
      return row.id
    },
    showList (users) {
      this.isLoading = false
      this.searchedTotal = users.total

      this.userList = users.items.map((user) => {
        this.isToggle[user.email] = false
        user.creation_date = user.creation_date * 1000
        return user
      })

      return users
    },
    toggleRowExpansion (row) {
      const expandRow = this.expanded.some((id) => row.id === id)
      const expandedArray = expandRow ? [] : [ row ]

      this.handleExpand(row, expandedArray)
    },
    userSearch (email) {
      this.pagination.currentPage = 1
      this.userList = []
      this.expanded = []
      this.pagination.offset = 0
      this.userInfo = undefined

      this.getUsers(email)
    }
  },
  name: 'User',
  async created () {
    await Promise.all([this.getTotal(), this.getUsers(this.searchQuery)])
  },
  data () {
    return {
      component: 'user',
      expanded: [],
      isLoading: false,
      isLoadingInfo: false,
      isToggle: {},
      pagination: {
        currentPage: 1,
        layout: 'prev, pager, next',
        limit: 50,
        offset: 0
      },
      searchedTotal: 0,
      searchQuery: this.$route.params.email || '',
      total: {},
      userInfo: undefined,
      userList: []
    }
  },
  mounted () {
    bus.$on('update-deleted-user-list', (id) => {
      const index = this.userList.findIndex(user => user.id === id)
      this.userList.splice(index, 1)
      this.total.users -= 1
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/User/User.js